export default {
    PasatiempoDeportes: 'Pasatiempo y deportes',
    MisterioTerror: 'Misterio y terror',
    AventurasViajes: 'Aventuras y viajes',
    FantasiaMundos: 'Fantasía y otros mundos',
    ArteCultura: 'Arte y cultura',
    CienciaTecnologia: 'Ciencia y tecnología',
    CienciasUniverso: 'Ciencias y universo',
    TecnologiaInventos: 'Tecnología e inventos',
    PensamientosEmociones: 'Pensamientos y emociones',
    HistoriaVidaReal: 'Historia y vida real',
    HumorCuriosidades: 'Humor y curiosidades',
    CocinaVidaCotidiana: 'Cocina y vida cotidiana',
    NaturalezaAnimales: 'Naturaleza y animales',
}